import { LIMPAR_DADOS_PAGAMENTO_ENCOMENDA } from '../types';

export default function limparDadosPagamentoEncomenda () {
  return {
    type: LIMPAR_DADOS_PAGAMENTO_ENCOMENDA
  }
}
